import { Box, Typography } from "@outschool/backpack";
import React from "react";

export default function DateSeparator({ date }: { date: string }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "1.2rem",
        marginY: "2rem",
      }}
    >
      <Box sx={{ flex: 1, height: "1px", backgroundColor: "divider" }} />
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ whiteSpace: "nowrap" }}
      >
        {date}
      </Typography>
      <Box sx={{ flex: 1, height: "1px", backgroundColor: "divider" }} />
    </Box>
  );
}
